angular.module("app").factory("ErrorModalFactory", ErrorModalFactory);

ErrorModalFactory.$inject = ['$uibModal'];

function ErrorModalFactory($uibModal) {


    function open(config, thenCallback) {
        $uibModal.open({
            templateUrl: 'app/modal/error.modal.html',
            controller: 'ErrorModalController',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            size: "lg",
            resolve: {
                config: function () {
                    return config;
                }
            }
        }).result.then(function () {
            if (thenCallback) {
                thenCallback();
            }
        });
    }

    return {
        open: open
    }
}